import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { Account } from '../../../shared/account.model';
import { Category } from '../../../../category/shared/category.model';
import { ChartOptions, ChartType } from 'chart.js';
import { Label, BaseChartDirective } from 'ng2-charts';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnChanges {

  @Input() accounts?: Account[];
  @Input() categories?: Category[];
  @Output() legendClicked = new EventEmitter<string[]>();
  @ViewChild(BaseChartDirective, { static: true }) baseChart?: BaseChartDirective;

  private _displayedLabels = '';

  pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'left',
      labels: {
        fontColor: '#999'
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          if (data.datasets && data.labels) {
            const dataset = data.datasets[tooltipItem.datasetIndex || 0];
            const label = data.labels[tooltipItem.index || 0];
            const currentValue = (dataset.data || [])[tooltipItem.index || 0] as number;
            return `${label} : \xA5${currentValue.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')} `;
          } else {
            return '';
          }
        },
      }
    },
    plugins: {
      labels: {
        render: 'percentage',
        precision: 1
      }
    }
  };
  pieChartLabels: Label[] = [];
  pieChartData: number[] = [];
  pieChartType: ChartType = 'pie';
  pieChartLegend = true;
  pieChartPlugins = [];
  pieChartColors = [
    {
      backgroundColor: ['#64B5F6', '#4FC3F7', '#4DD0E1', '#4DB6AC', '#81C784', '#AED581', '#DCE775', '#FFF176', '#FFD54F', '#FFB74D'],
    },
  ];

  constructor() { }

  ngOnChanges() {
    if (this.accounts && this.categories) {
      const hash: { [key: string]: number } = this.accounts
        .map(account => ({ categoryName: account.category && account.category.name || 'undefined', amount: account.amount || 0 }))
        .reduce((acc: { [key: string]: number }, cur) => {
          acc[cur.categoryName] = (acc[cur.categoryName] || 0) + cur.amount;
          return acc;
        }, {});
      const data = Object.keys(hash).map(key => ({ categoryName: key, amount: hash[key] })).sort((a, b) => a.amount < b.amount ? 1 : -1);
      this.pieChartLabels = data.map(d => d.categoryName);
      this.pieChartData = data.map(d => d.amount);
      this.pieChartColors[0].backgroundColor = this.pieChartLabels
        .map(label => (this.categories || [])
        .find(cat => label === cat.name))
        .map(cat => cat && cat.color ? cat.color : '#999');
    }
  }

  onChartClick() {
    setTimeout(() => {
      if (this.baseChart && this.baseChart.chart.data.labels) {
        const metaData = this.baseChart.chart.getDatasetMeta(0).data;
        const displayedLabels = this.baseChart.chart.data.labels.map((l, i) => !metaData[i].hidden ? l as string : '').filter(l => l);
        if (displayedLabels.join(',') !== this._displayedLabels) {
          this.legendClicked.emit(displayedLabels);
          this._displayedLabels = displayedLabels.join(',');
        }
      }
    }, 0);
  }
}
